import { render, staticRenderFns } from "./firmDynamic.vue?vue&type=template&id=520e996e&scoped=true&"
import script from "./firmDynamic.vue?vue&type=script&lang=js&"
export * from "./firmDynamic.vue?vue&type=script&lang=js&"
import style0 from "./firmDynamic.vue?vue&type=style&index=0&id=520e996e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e996e",
  null
  
)

export default component.exports